export const chartFields = {
  max: 3,
} as const;

export const imageRotationDeg = {
  step: 90,
} as const;

export const imageBrightnessPct = {
  min: 0,
  max: 5,
  step: 0.05,
  default: 1,
} as const;

export const imageContrastPct = {
  min: 0,
  max: 2,
  step: 0.05,
  default: 1,
} as const;

export const imageOpacityPct = {
  min: 0,
  max: 1,
  step: 0.01,
  default: 1,
} as const;

export const threeDTopics = {
  min: 1,
  // IMPORTANT: GPU-based picking implementation cannot support more than 8
  // point clouds at a time. Increasing the max for a single panel past 8
  // requires a reworking of the GPU picking logic.
  max: 6,
} as const;

export const pointSize = {
  min: 1,
  max: 25,
  step: 0.1,
  default: 3,
} as const;
